import {IController, IScope, ITimeoutService} from "angular";
import * as angular from "angular";
import * as _ from "lodash";
import {ServiceAreaRequests} from "../../../service-areas/services/service-area-requests.service";
import {RouteRequestsService} from "../../../routes/services/routes-requests.service";
import {LeanPlanningAlertsService} from "../../services/lean-planning-alerts.factory";
import {LeanPlanningDialogService} from "../../services/lean-planning-dialogs-service.factory";
import {LeanPlanningRequestsService} from "../../services/plan-requests.factory";
import {SortType} from "../../../commons/types/sort.type";

export class PlanningRoutesQueryTable implements IController {
  ids: string[];
  projectId: string;
  tags: any;
  range: any;
  queryString: any;
  excludeMode: any;
  selectedIds: any;
  routesCount?: any;
  showRoutes: any;
  group: any;
  statuses: any;
  branchIds: any;
  serviceAreaIds: any;
  agentIds: any;
  agentSkills: string[];
  resourceIds: any;
  highlightedRoute: any;
  loading: any;
  onQueryChange: Function;
  onSelectRoutesChanged: Function;
  onToggleShowRoute: Function;
  onToggleBlockRoute: Function;
  onShowSuggestions?: Function;
  onShownRouteChanged: Function;
  onHandleUnpackedDeliveries: Function;
  onReoptimizeRoute: Function;
  onBlockRoute: Function;
  onUnBlockRoute: Function;
  onResetRoute: Function;
  onUpdateBranches: Function;
  onUpdateResource: Function;
  onUpdateLogisticsVehicle: Function;
  onManageAssistants: Function;
  onDeleteRoute: Function;
  onChangeRouteColor: Function;


  public isLoading: boolean = false;
  public displayAsItems: boolean = false;
  public loadLimit: number = 15;
  public routesRef: any;
  public selectedKeys: any = {};
  public showKeys: any = {};
  public serviceAreasMap: any = {};
  public infiniteScroll: any;
  public sortTypesValues: any;
  public asceDescIconsMap: any;
  public sortType: any;
  public selectedSortValue: any;
  public hasFleetManagementPermission: boolean;

  constructor(private $planningRoutes, private $infiniteScroll, private serviceAreaRequests: ServiceAreaRequests,
              private leanPlanningDialogService: LeanPlanningDialogService, private leanPlanningAlertsService: LeanPlanningAlertsService, private $scope: IScope, private leanPlanningRequestsService: LeanPlanningRequestsService,
              private $log, private $timeout: ITimeoutService, private routeRequestsService: RouteRequestsService, private commonsConstants, private IAMPermissions) {
    this.routesRef = this.$planningRoutes();
  }

  $onInit() {
    this.sortTypesValues = {
      sortNotBefore: {asc: 'notBefore,asc', desc: 'notBefore,desc'},
      sortLogisticVehiclePlateNumber: {asc: 'planningResource.mainLogisticsVehicleReference.licensePlateNumber,asc', desc: 'planningResource.mainLogisticsVehicleReference.licensePlateNumber,desc'},
    };

    this.hasFleetManagementPermission = this.IAMPermissions.hasPermission('fleetManagement.vehicles.list');
    this.asceDescIconsMap = this.commonsConstants.sortIconsMap;

    this.routesRef.$query(this._getRoutesQuery());
    this.infiniteScroll = this.$infiniteScroll(this.routesRef, this.loadLimit);

    this.selectedKeys = {};
    _.forEach(this.selectedIds, (selectedId) => {
      this.selectedKeys[selectedId] = true;
    });


    this.routesRef.$onChange(this.$scope, (routes) => {
      let routeIdsToDelete = [];
      let routeIdsToUpdate = [];
      _.forEach(routes, (route) => {
        if (route) {
          const routeToDelete = _.isEqual(route.status, 'Deleted'),
            showRouteRef = _.find(this.showRoutes, function (showRoute) {
              return showRoute.rid === route.rid;
            })

          if (routeToDelete) {
            routeIdsToDelete.push(route.rid);
          }

          if (!!showRouteRef) {
            if (showRouteRef.updatedAt < route.updatedAt) {
              routeIdsToUpdate.push(route.rid);
            }
          }
        }
      });
      if (routeIdsToDelete.length) {
        this.infiniteScroll.removeItems(routeIdsToDelete);
      }
      // ctrl.onShownRouteChanged({deleteIds: routeIdsToDelete, updateIds: routeIdsToUpdate})

    });

  };

  $onChanges(changes) {
    if (changes.showRoutes && !changes.showRoutes.isFirstChange()) {
      const showRoutesCurrentValue = changes.showRoutes.currentValue,
        showRoutesPreviousValue = changes.showRoutes.previousValue;

      if (!_.isEqual(showRoutesCurrentValue.length, showRoutesPreviousValue.length)) {
        this.showKeys = {};
        _.forEach(showRoutesCurrentValue, (showRoute) => {
          this.showKeys[showRoute.rid] = true;
        })
      }
    }

    if (changes.selectedIds && !changes.selectedIds.isFirstChange()) {
      this.selectedKeys = {};
      _.forEach(this.selectedIds, (selectedId) => {
        this.selectedKeys[selectedId] = true;
      });
    }

    if (
      (changes.ids && !changes.ids.isFirstChange()) ||
      (changes.tags && !changes.tags.isFirstChange()) ||
      (changes.range && !changes.range.isFirstChange()) ||
      (changes.statuses && !changes.statuses.isFirstChange()) ||
      (changes.serviceAreaIds && !changes.serviceAreaIds.isFirstChange()) ||
      (changes.agentIds && !changes.agentIds.isFirstChange()) ||
      (changes.agentSkills && !changes.agentSkills.isFirstChange()) ||
      (changes.resourceIds && !changes.resourceIds.isFirstChange()) ||
      (changes.branchIds && !changes.branchIds.isFirstChange()) ||
      (changes.group && !changes.group.isFirstChange()) ||
      (changes.queryString && !changes.queryString.isFirstChange())
    ) {
      this._loadRoutes()
    }

  };

  /////////////////////////////////////////////////////////////////////////////

  // ******************************
  //        External methods
  // ******************************


  onSortTypeChange(sortName) {
    const isSameSortName = !!this.selectedSortValue && _.isEqual(this.selectedSortValue.name, sortName);
    const newType = isSameSortName ? _.isEqual(this.selectedSortValue.type, SortType.asc) ? SortType.desc : SortType.asc : SortType.asc;

    this.selectedSortValue = {
      name: sortName,
      type: isSameSortName ? newType : SortType.asc,
      value: isSameSortName ? this.sortTypesValues[sortName][newType] : this.sortTypesValues[sortName].asc
    }

    this._loadRoutes();
  }

  onToggleSelectAll() {
    // ctrl.selectedKeys = {};
    this.onSelectRoutesChanged({
      selectedIds: [],
      excludeMode: !this.excludeMode
    });
  }

  onToggleRoute(route) {
    this.selectedKeys[route.rid] = !this.selectedKeys[route.rid];
    this.onSelectRoutesChanged({
      selectedIds: _.keys(_.pickBy(this.selectedKeys, _.identity)),
      excludeMode: this.excludeMode
    });
  }

  onAssignRoute(route) {
    this.loading = true;
    this.leanPlanningRequestsService.assignRouteToAgent(route.rid, route.agentId)
      .then(() => {
        this.leanPlanningAlertsService.assignSuccess();
      })
      .catch((error) => {
        this.leanPlanningAlertsService.assignError();
        this.$log.error('Failed to assign route to driver @planningRoutesTable@onAssignRoute', error)
      })
      .finally(() => {
        this.loading = false;
      })
  }

  onRouteReset(route) {
    this.leanPlanningDialogService.routeReset(route)
      .then((payload) => {
        this.loading = true;
        return this.routeRequestsService.resetRoutes(route.rid, undefined, undefined, undefined, undefined, payload.resetOnlyAssignAgentServices);
      })
      .then(() => {
        this.leanPlanningAlertsService.resetSuccess();
      })
      .catch((error) => {
        if (error) {
          this.leanPlanningAlertsService.resetError();
          this.$log.error('Failed to reset route', error);
        } else {
          this.$log.info('Dialog Closed');
        }
      })
      .finally(() => {
        this.loading = false;
      })
  }

  onAssignRouteAndSelectDriver(route, ev) {
    this.leanPlanningDialogService.manualAssignRoute(ev, route.rid)
      .then((payload) => {
        this.loading = true;
        return this.leanPlanningRequestsService.assignRouteToAgent(route.rid, payload.agentId, payload.assignServices);
        // return RouteRequests.assignRouteToAgent(route.rid, payload.agentId, payload.doForce);
      })
      .then(() => {
        this.leanPlanningAlertsService.assignSuccess();
      })
      .catch((error) => {
        if (error) {
          this.leanPlanningAlertsService.assignError();
          this.$log.error('Failed to assign route to driver @planningRoutesTable@onAssignRoute', error);
        } else {
          this.$log.info('Dialog Closed');
        }
      })
      .finally(() => {
        this.loading = false;
      })
  }

  setEvents() {
    const div1 = document.getElementById('header');
    const div2 = document.querySelectorAll('.md-virtual-repeat-scroller')[0];

    div2.addEventListener('scroll', e => {
      div1.scrollTop = div2.scrollTop;
      div1.scrollLeft = div2.scrollLeft;
    }, {passive: true})
  }


  // ******************************
  //        Internal methods
  // ******************************

  private _loadRoutes() {
    if (!this.isLoading) {
      this.isLoading = true;
      this.routesRef.$query(this._getRoutesQuery()).then(
        () => {
          this.infiniteScroll.reload();
          this.onQueryChange();
          this.$timeout(0).then(() => {
            this.isLoading = false;
          })
        },
        (resp) => {
          this.$log.error('Fail to $query', resp);
        }
      );
    }
  }

  private _getRoutesQuery() {
    return {
      ids: this.ids,
      expandServices: false,
      expandTasks: false,
      expandTasksExt: false,
      query: this.queryString,
      from: this.range.dateStart,
      to: this.range.dateEnd,
      status: this.statuses,
      branchIds: this.branchIds,
      areaIds: this.serviceAreaIds,
      agentIds: this.agentIds,
      skill: this.agentSkills,
      resourceIds: this.resourceIds,
      statusGroup: this.group,
      tags: this.tags,
      limit: !this.projectId ? this.loadLimit : undefined,
      sort: _.get(this.selectedSortValue, 'value')
    }
  }

}

angular
  .module('bringoz.admin.lean-planning')
  .component('planningRoutesQueryTable', {
    bindings: {
      ids: '<?',
      projectId: '<?',
      tags: '<?',
      range: '<',
      queryString: '<',
      excludeMode: '<',
      selectedIds: '<',
      onSelectRoutesChanged: '&',
      routesCount: '<?',
      showRoutes: '<',
      group: '<',
      statuses: '<',
      branchIds: '<',
      serviceAreaIds: '<',
      agentIds: '<',
      agentSkills: '<',
      resourceIds: '<',
      highlightedRoute: '<',
      loading: '<',
      columns: '<',
      onQueryChange: '&',
      onToggleShowRoute: '&',
      onToggleBlockRoute: '&',
      onShowSuggestions: '&?',
      onShownRouteChanged: '&',
      onHandleUnpackedDeliveries: '&',
      onReoptimizeRoute: '&',
      onBlockRoute: '&',
      onUnBlockRoute: '&',
      onResetRoute: '&',
      onUpdateBranches: '&',
      onUpdateResource: '&',
      onUpdateLogisticsVehicle: '&',
      onManageAssistants: '&',
      onDeleteRoute: '&',
      onChangeRouteColor: '&'
    },
    template: require('./planning-routes-query-table.html').default,
    controller: PlanningRoutesQueryTable
  });
